"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileNavigation = void 0;
const react_1 = __importStar(require("react"));
require("./navigation.scss");
const consts_1 = require("../../common/consts");
const MobileNavigation = () => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement("nav", { className: "mobile-navigation" },
        react_1.default.createElement("button", { className: "menu-button", "aria-expanded": isOpen, onClick: () => setIsOpen(!isOpen) }, isOpen ? (react_1.default.createElement("img", { src: "/images/logos/close-icon.png", alt: "Close menu", className: "close-icon" })) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "hamburger-dash" }, "\u00A0"),
            react_1.default.createElement("div", { className: "hamburger-dash" }, "\u00A0"),
            react_1.default.createElement("div", { className: "hamburger-dash" }, "\u00A0")))),
        isOpen && (react_1.default.createElement("div", { className: "mobile-menu" },
            react_1.default.createElement("a", { className: "mobile-link", href: `#${consts_1.SECTION_IDS.about}`, onClick: () => setIsOpen(false) }, "About"),
            react_1.default.createElement("a", { className: "mobile-link", href: `#${consts_1.SECTION_IDS.discord}`, onClick: () => setIsOpen(false) }, "Discord"),
            react_1.default.createElement("a", { className: "mobile-link", href: `#${consts_1.SECTION_IDS.events}`, onClick: () => setIsOpen(false) }, "Events"),
            react_1.default.createElement("a", { className: "mobile-link", href: `#${consts_1.SECTION_IDS.hosts}`, onClick: () => setIsOpen(false) }, "Hosts"),
            react_1.default.createElement("a", { className: "mobile-link", href: `#${consts_1.SECTION_IDS.contact}`, onClick: () => setIsOpen(false) }, "Contact Us")))));
};
exports.MobileNavigation = MobileNavigation;
